import React from 'react';
import { Link } from 'react-router-dom';
export const taskTypeLabel = value => ({follow_up:'Follow-up',confirmation:'Confirmation',quotation:'Quotation',preparation:'Preparation'})[value] || 'Follow-up';
export default function TaskSource({task}) {
 return <div className="my-2 space-y-1 text-xs text-gray-500">
  <p>{taskTypeLabel(task.taskType)}{task.source==='whatsapp'?' · Auto-captured from WhatsApp':''}</p>
  {task.evidence?.quote&&<details><summary className="cursor-pointer">Source message</summary><blockquote className="mt-1 border-l-2 pl-2">{task.evidence.quote}</blockquote>{task.conversationId&&<Link className="text-primary-700 underline" to={`/inbox/${task.conversationId}`}>Open conversation</Link>}</details>}
 </div>;
}
